import React from "react";
import { PROCESS, SERVICES, TECH_STACK } from "../../data/content";
import { Reveal, SectionHeading } from "../ui";

const Services = () => (
  <section id="services" className="section bg-ink-900/40">
    <div className="container">
      <SectionHeading
        eyebrow="Custom software"
        title="Need something unique? We build it."
        subtitle="The engineering team behind KNTO Pass, available for your platform, app or hardware integration."
      />

      <div className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map(({ icon: Icon, title, desc }, i) => (
          <Reveal key={title} delay={i * 80} className="card card-hover p-7">
            <Icon className="h-7 w-7 text-brand-500" />
            <h3 className="mt-5 font-display text-lg font-semibold text-white">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink-400">{desc}</p>
          </Reveal>
        ))}
      </div>

      {/* Process */}
      <div className="mt-24">
        <Reveal as="h3" className="text-center font-display text-2xl font-semibold text-white">
          How we work
        </Reveal>
        <div className="relative mt-12">
          <div
            aria-hidden="true"
            className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-transparent via-brand-600/50 to-transparent md:block"
          />
          <ol className="grid gap-8 md:grid-cols-4">
          {PROCESS.map(({ icon: Icon, title, desc }, i) => (
            <Reveal as="li" key={title} delay={i * 100} className="relative text-center">
              <span className="relative mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-brand-600/40 bg-ink-950 text-brand-400 shadow-glow">
                <Icon className="h-6 w-6" />
              </span>
              <p className="mt-5 text-xs font-semibold uppercase tracking-[0.2em] text-ink-500">Step 0{i + 1}</p>
              <h4 className="mt-2 font-display text-lg font-semibold text-white">{title}</h4>
              <p className="mx-auto mt-2 max-w-[16rem] text-sm leading-relaxed text-ink-400">{desc}</p>
            </Reveal>
          ))}
          </ol>
        </div>
      </div>

      {/* Stack */}
      <Reveal className="mt-24 text-center">
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-ink-400">Our stack</p>
        <ul className="mx-auto mt-6 flex max-w-4xl flex-wrap justify-center gap-2">
          {TECH_STACK.map((t) => (
            <li
              key={t}
              className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-sm font-medium text-ink-200"
            >
              {t}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);

export default Services;
